import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import { Link, Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { confirmForgotPassword } from "../../crud/auth.crud";
import { showErrorMessage, showSuccessMessageIcon } from "../../actions/notification";

function ConfirmForgotPassword(props) {
	const [isRequested, setRequested] = useState(false);
	const { intl } = props;
	const passRef = React.createRef();
	const rePassRef = React.createRef();
	if (isRequested) {
		return <Redirect to="/auth" />;
	}

	return (
		<div
			className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper"
			style={{ paddingTop: 185 }}
		>
			<div className="kt-login__body">
				<div className="kt-login__form">
					<div className="kt-login__title">
						<h3>
							<FormattedMessage id="AUTH.FORGOT.CONFIRM" />
						</h3>
					</div>

					<Formik
						initialValues={{ password: "", rePassword: "" }}
						onSubmit={(values, { setStatus, setSubmitting }) => {
							if (!values.password) {
								setSubmitting(false);
								passRef.current.focus();
								return showErrorMessage("Please enter new password.");
							} else {
								if (values.password.length < 6) {
									setSubmitting(false);
									passRef.current.focus();
									return showErrorMessage("Password must be at least 6 characters.");
								}
								if (values.password.length > 20) {
									setSubmitting(false);
									passRef.current.focus();
									return showErrorMessage("Password must be longer than 20 characters.");
								}
								const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{6,}$/;
								if (!regex.test(values.password)) {
									setSubmitting(false);
									passRef.current.focus();
									return showErrorMessage(
										"Password contains at least a upper case, lower case, symbol and a number. Except space character"
									);
								}
							}

							if (!values.rePassword) {
								setSubmitting(false);
								rePassRef.current.focus();
								return showErrorMessage("Please confirm new password.");
							}

							if (values.password !== values.rePassword) {
								setSubmitting(false);
								passRef.current.focus();
								return showErrorMessage("Invalid. Password and re-password do not match.");
							}

							// let email = props.match.params.email;
							let strConfirm = props.match.params.strConfirm;

							confirmForgotPassword(strConfirm, values.password)
								.then(({ data }) => {
									if (data.signal) {
										if (data?.data === 1) {
											showSuccessMessageIcon("Change password success. Please use new password to login system.");
											setRequested(true);
										} else if (data?.data === 2) {
											setRequested(true);
											return showErrorMessage("Request failed because version validation has expired");
										} else if (data?.data === 3) {
											setRequested(true);
											return showErrorMessage("Not found user.");
										} else {
											setRequested(true);
											return showErrorMessage("Opps! Something was wrong!");
										}
									} else {
										setRequested(false);
										return showErrorMessage(data.message);
									}
								})
								.catch(() => {
									setSubmitting(false);
									setStatus(intl.formatMessage({ id: "AUTH.VALIDATION.NOT_FOUND" }, { name: values.password }));
								});
						}}
					>
						{({ values, status, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
							<form onSubmit={handleSubmit} className="kt-form">
								{status && (
									<div role="alert" className="alert alert-danger">
										<div className="alert-text">{status}</div>
									</div>
								)}

								<div className="form-group">
									<TextField
										type="password"
										label="Password"
										margin="normal"
										fullWidth={true}
										name="password"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.password}
										autoFocus
										inputRef={passRef}
									/>
								</div>

								<div className="form-group">
									<TextField
										type="password"
										label="Re-password"
										margin="normal"
										fullWidth={true}
										name="rePassword"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.rePassword}
										inputRef={rePassRef}
									/>
								</div>

								<div className="kt-login__actions">
									<Link to="/auth">
										<button type="button" className="btn btn-secondary btn-elevate kt-login__btn-secondary">
											Back
										</button>
									</Link>

									<button
										type="submit"
										className="btn btn-primary btn-elevate kt-login__btn-primary"
										disabled={isSubmitting}
									>
										Confirm
									</button>
								</div>
							</form>
						)}
					</Formik>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(connect(null, auth.actions)(ConfirmForgotPassword));
